import { CommonDateModeEnum, DatePreset, StartDateModeEnum } from './date-component.models';

export const defaultStartDatePreset = {
    mode: StartDateModeEnum.beginningOfMonth,
    value: 'yyyy-MM-01'
};
export const startDateModePresets: DatePreset[] = [
    {
        mode: StartDateModeEnum.beginningOfMonth,
        label: 'Beginning of month (yyyy-MM-01)',
        value: 'yyyy-MM-01'
    },
    {
        mode: StartDateModeEnum.beginningOfYear,
        label: 'Beginning of year (yyyy-01-01)',
        value: 'yyyy-01-01'
    },
    {
        mode: CommonDateModeEnum.calendarDate,
        label: 'Fixed date',
        value: null
    },
    {
        mode: CommonDateModeEnum.custom,
        label: 'Advanced',
        value: null
    }
];
